module.exports = __webpack_public_path__ + "static/img/male3.372e35e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/comment/male3.png
// module id = OaFZ
// module chunks = 1